import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
// import * as actions from './actions'
// import * as mutations from './mutations'
import * as getters from './getters'
import error from './modules/error'
// import user from './user'
import certify from './certify'

Vue.use(Vuex)

// const userInfo = user

const _appArr = [
  //{ label: '全部', value : '' },
  { label: '基础云', value: 'jcloud' },
  { label: '数据云', value: 'JCloudData' },
  { label: '域名', value: 'domain' },
  { label: '云市场', value: 'jcloudmark' }
]
const _serviceArr = {
  '': [{ label: '全部', value: '' }],
  jcloud: [
    { label: '全部', value: '' },
    { label: '云主机', value: 'vm' },
    { label: '云硬盘', value: 'disk' },
    { label: '容器服务', value: 'nativecontainer' },
    { label: '公网IP', value: 'ip' },
    { label: '负载均衡', value: 'balance' },
    { label: '云数据库 MySQL', value: 'database' },
    { label: '云数据库 MySQL 只读实例', value: 'db_ro' },
    { label: '云数据库 SQL Server', value: 'sqlserver' },
    { label: '云数据库 MongoDB', value: 'mongodb' },
    { label: '缓存Redis', value: 'redis' },
    { label: '云存储', value: 'storage' },
    { label: 'CDN', value: 'cdn' },
    { label: 'NAT网关', value: 'nat_gw' },
    { label: 'VPN', value: 'vpn' },
    { label: 'IP高防', value: 'ipanti' },
    { label: '视频直播', value: 'live' },
    { label: 'web应用防火墙', value: 'waf' },
    { label: '云解析', value: 'domainservice' }
  ],
  JCloudData: [
    { label: '全部', value: '' },
    { label: '数据工厂', value: 'datafactory' },
    { label: '数据计算服务', value: 'datacompute' },
    { label: 'jmr', value: 'jmr' },
    { label: '流数据总线', value: 'streambus' },
    { label: '流计算', value: 'streamcompute' }
  ],
  domain: [{ label: '全部', value: '' }, { label: '域名', value: 'domain' }],
  jcloudmark: [
    { label: '全部', value: '' },
    { label: '云市场自营产品', value: 'web_self' },
    { label: '云市场第三方产品', value: 'web_other' }
  ],
  loadBalance: [{ label: '全部', value: '' }]
}

const debug = process.env.NODE_ENV !== 'production'

const plugins = debug ? [createLogger()] : []

const state = {
  isLoading: false,
  // userInfo: userInfo,
  backPath: '', //返回路径
  appCodeArr: _appArr,
  serviceCodeArr: _serviceArr,
  totalCount: 0,
  certify: certify,
  collapse: true
}

export default new Vuex.Store({
  state,
  actions: {
    setLoadingAct({ commit }, _isLoading) {
      commit('setLoading', _isLoading)
    },
    updateBackPathAct({ commit }, _path) {
      commit('updateBackPath', _path)
    },
    updateAppCodeAct({ commit }, _arr) {
      commit('updateAppCodeArr', _arr)
    },
    updateServiceCodeAct({ commit }, _obj) {
      commit('updateServiceCodeArr', _obj)
    },
    updateTotalCountAct({ commit }, _count) {
      commit('updateTotalCount', _count)
    },
    updateCertifyAct({ commit }, _count) {
      commit('updateCertify', _count)
    },
    updateCollapseAct({ commit }, _collapse) {
      commit('updateCollapse', _collapse)
    }
  },
  getters,
  mutations: {
    setLoading(state, _isLoading) {
      state.isLoading = _isLoading
    },
    updateUserInfo(state, _adminPin) {
      state.userInfo.adminPin = _adminPin
    },
    updateBackPath(state, _path) {
      state.backPath = _path
    },
    updateAppCodeArr(state, _arr) {
      state.appCodeArr = _arr
    },
    updateServiceCodeArr(state, _obj) {
      state.serviceCodeArr = _obj
    },
    updateTotalCount(state, _count) {
      state.totalCount = _count
    },
    updateCertify(state, _count) {
      state.certify = Object.assign({}, state.certify, _count)
    },
    updateCollapse(state, _collapse) {
      state.collapse = _collapse
    }
  },
  modules: {
    error
  },
  strict: debug,
  plugins: plugins
})
